<template>
<section class="action-grid p-4">
    <div class="max-w-7xl mx-auto" ref="trigger">
        <div class="grid" v-if="trigger">
            <SmoothLoader v-for="(item, i) in grid_items" :delay="i * 200" :trigger="trigger">
                <Link :href="item.url" class="bg-primary-700 rounded-md px-4 py-8 flex items-center justify-center h-full">
                    <div>
                        <span class="headline text-2xl mb-4 text-white block text-center font-headline font-bold" v-html="item.headline">
                        </span>
                        <p v-if="item.blurb" class="text-center font-body text-gray-300 text-lg" v-html="item.blurb"></p>
                        <div v-if="item.icon" class="flex justify-center mt-8">
                            <span v-html="item.icon" class="icon-container w-12 h-12 rounded-full bg-white flex items-center justify-center"></span>
                        </div>
                    </div>
                </Link>
            </SmoothLoader>
        </div>
    </div>
</section>
</template>

<script>
import { ref } from 'vue';
export default {
    
    props: ['data'],

    setup(props) {

        const trigger = ref(null);

        return {
            ...props.data,
            trigger
        }
    }

}
</script>